import { render, staticRenderFns } from "./auctionPackagesOverview.vue?vue&type=template&id=2a20fd46&scoped=true&lang=pug"
import script from "./auctionPackagesOverview.vue?vue&type=script&lang=js"
export * from "./auctionPackagesOverview.vue?vue&type=script&lang=js"
import style0 from "./auctionPackagesOverview.vue?vue&type=style&index=0&id=2a20fd46&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a20fd46",
  null
  
)

export default component.exports